import { useEffect, useState } from 'react';

import { Box } from '@aicon-dev/caas-ui';

import { PagePopup } from '~/components/ui/PagePopup';
import { Policy } from '~/modules/policy';
import { useNavigate } from '~/router';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <PagePopup
      title="개인정보취급방침"
      visible={visible}
      onClose={() => setVisible(false)}
      onExited={() => navigate(-1)}
    >
      <Box p="16">
        <Policy.Privacy />
      </Box>
    </PagePopup>
  );
}
